import React from 'react';
import './ImgTag.scss';

const ImgTag = (props) => {
    return (
        <img
            className = {props.className ? props.className : ''}
            src = {props.src ? props.src : ''}
            id = {props.id ? props.id : ''}
            alt = {props.alt ? props.alt : 'eb-image'}
            {...props}
        />
    );
}

export default ImgTag;
